var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const CachingService = (service) => {
    // a cache of results
    const cache = {};
    // a cache of inflight calls, used because e.g. the activity page can launch
    //  dozens of calls for the same lookup. If we didn't cache the calls themselves,
    //  then you'd get loads of api calls being made until the first one returned and populated
    //  the result cache, diminishing the effectiveness.
    const callCache = {};
    const innerGet = service.get;
    const getSetViaCache = (id) => __awaiter(void 0, void 0, void 0, function* () {
        if (cache[id]) {
            if (yield callCache[id]) {
                delete callCache[id];
            }
            return cache[id];
        }
        if (!callCache[id]) {
            callCache[id] = innerGet.bind(service)(id);
        }
        const response = yield callCache[id];
        cache[id] = response;
        return Object.assign({}, response);
    });
    service.get = getSetViaCache;
    return service;
};
